import { faCheckCircle, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomSheet from "components/reusable/BottomSheet";
import ErrorMessage from "components/reusable/ErrorMessage";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import gift_cards_config from "./config";

function AddGiftCard({ onClose, onNewCard }) {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { user } = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [loading, setLoading] = useState(false);
  const [selectedType, setSelectedType] = useState(0);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await apiPost(pathObj.giftCard, {
        title: gift_cards_config[selectedType].type,
        amount: data.amount,
        sender_name: data.sender_name,
        receiver_username: data.receiver_username,
        message: data.message,
      });
      if (res.data.success) {
        notification.success(res.data.message || t("OPERATION_SUCCESS"));
        onNewCard()
        onClose();
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <BottomSheet
        open={true}
        onClose={() => {
          onClose();
        }}
        title={t("GIFT_CARD_SELECT")}
      >
        <div className="flex  flex-col justify-center items-center w-full">
          <div className="grid grid-cols-4 gap-2 w-full">
            {gift_cards_config.map((it, idx) => (
              <div className="relative w-full flex justify-center items-center flex-col">
                <div
                  className={`w-12 h-12 rounded-full ${it.background} flex justify-center items-center cursor-pointer`}
                  onClick={() => {
                    setSelectedType(idx);
                  }}
                >
                  <FontAwesomeIcon icon={it.icon} className={`${it.color} text-xl`} />
                </div>
                <span className="font-medium mt-1">{t(it.title)}</span>
                {selectedType === idx && <FontAwesomeIcon icon={faCheckCircle} className="text-white absolute top-[0.5rem] right-[1rem]" />}
              </div>
            ))}
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="w-full">
            <div className="text-lg font-medium  mt-5 mb-2">{t("AMOUNT")}</div>
            <div className="bg-card p-4 rounded-lg">
              <div className="flex justify-start gap-3 items-center">
                <div className="font-medium text-lg text-white">{user.wallet_currency}</div>
                <input
                  type="number"
                  id="amount"
                  inputType="numeric"
                  className="inputform border-0 text-heading text-white font-medium text-sm rounded-base block w-full px-3 rounded-lg py-2.5 shadow-xs placeholder:text-body"
                  placeholder={t("AMOUNT_FIELD")}
                  onKeyDown={(e) => {
                    e.target.value = e.target.value.trim();
                  }}
                  {...register("amount", {
                    required: t("AMOUNT_EMPTY"),
                  })}
                  required
                />
              </div>
            </div>

            <div className="text-lg font-medium mt-5 mb-2">{t("GIFT_CARD_GIFTED")}</div>
            <input
              type="text"
              id="receiver_username"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              placeholder={t("USERNAME")}
              {...register("receiver_username", {
                required: t("REGISTER_USERNAME"),
              })}
              required
            />
            <ErrorMessage message={errors?.receiver_username?.message} />

            <div className="text-lg font-medium mt-5 mb-2">{t("FROM")}</div>
            <input
              type="text"
              id="sender_name"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              {...register("sender_name", {
                required: t("FROM"),
              })}
              required
            />
            <ErrorMessage message={errors?.sender_name?.message} />

            <div className="text-lg font-medium mt-5 mb-2">{t("MESSAGE")}</div>
            <input type="text" id="message" className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body" {...register("message", {})} />

            <div className="w-full mt-5">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("GIFT_CARD_ADD")}
                </button>
              )}
            </div>
          </form>
        </div>
      </BottomSheet>
    </>
  );
}

export default AddGiftCard;
